export default "/images/ipaymer-hover-light.svg?09088fc2c713b289ca5f4b082ec27979";